// src/Camera.js
import React ,{lazy} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { initAnalytics } from './utilities/analytics.js';


import Container from './layouts/Container';

import PageLanding from './pages/PageLanding';
import PageHint from './pages/PageHint';
import PageCaptured from './pages/PageCaptured';
import PageCapturedPalette from './pages/PageCapturedPalette';
import PageResult from './pages/PageResult';
import PageResultTemplate from './pages/PageResultTemplate';
import PageResultGenerator from './pages/PageResultGenerator';

initAnalytics()
function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route exact path="/" element={<PageLanding/>} />
          <Route path="/:type/hint" element={<Container className='container-hint'><PageHint/></Container>} />
          <Route path="/:type/captured" element={<Container><PageCaptured/></Container>} />
          <Route path="/:type/palette" element={<Container><PageCapturedPalette/></Container>} />

          <Route exact path="/basic" element={<Navigate replace to="/basic/hint" />} />
          <Route exact path="/expert" element={<Navigate replace to="/expert/hint" />} />

          <Route path="/:type/result" element={<PageResult/>} />
          <Route path="/:type/result-template" element={<PageResultTemplate/>} />
          {/* <Route path="/generator" element={<PageResultGenerator/>} /> */}
          <Route path="/*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;